import { Role } from "./role";

export class User {

    idTariffAgent?: number;

    active!: boolean;

    name!: string;

    surname!: string;

    agentFunctionsDto: Role[] = [];

}